<template>
    <div id="device-create-view" class="view form-view">
        <h2>{{ $t('createDevice.title') }}</h2>

        <device-form :form="form" :handler="createDevice"></device-form>
    </div>
</template>

<script>
import DeviceForm from './components/DeviceForm'
import toast from '../../plugins/izitoast'
import DeviceApi from '@/api/DeviceApi'
import VehicleApi from '@/api/VehicleApi'
import FleetApi from '@/api/FleetApi'
import { arrayToBitFlag } from '@/helpers/Utils'

const deviceApi = new DeviceApi()
const vehicleApi = new VehicleApi()
const fleetApi = new FleetApi()

export default {
    name: 'DeviceCreate',
    components: {
        DeviceForm
    },
    mounted () {
        this.vehicleId = this.$route.query.vehicleId
        this.fleetId = this.$route.query.fleetId
        if (null != this.vehicleId) {
            this.getVehicle()
        }
        if (null != this.fleetId) {
            this.getFleet()
        }
    },
    data () {
        return {
            vehicleId: null,
            fleetId: null,
            form: {
                hardwareId: null,
                dataToCapture: [],
                channels: [],
                deviceModelId: null,
                deviceProtocolId: null,
                firmwareVersion: null,
                automaticVideoDownload: false,
                enabled: true,
                simNumber: null,
                serialNumber: null,
                customerSim: false,
                fleet: null,
                vehicle: null,
                organization: null
            }
        }
    },
    methods: {
        async createDevice (form) {
            const response = await deviceApi.createDevice({
                hardwareId: form.hardwareId,
                dataToCapture: arrayToBitFlag(form.dataToCapture),
                channelFlag: arrayToBitFlag(form.channels),
                deviceModelId: form.deviceModelId,
                deviceProtocolId: form.deviceProtocolId,
                firmwareVersion: form.firmwareVersion ? form.firmwareVersion : null,
                simNumber: form.simNumber ? form.simNumber : null,
                serialNumber: form.serialNumber ? form.serialNumber : null,
                enabled: form.enabled,
                customerSim: form.customerSim,
                automaticVideoDownload: form.automaticVideoDownload,
                fleetId: form.fleet ? form.fleet.id : '',
                vehicleId: form.vehicle ? form.vehicle.id : '',
                organizationId: form.organization ? form.organization.id : ''
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('Device successfully created.')
            if (this.hasAllRoles(['DeviceUpdate'])) {
                this.$router.push('/settings/devices/edit/' + response.payload)
            }
        },
        async getVehicle () {
            const response = await vehicleApi.getVehicle(this.vehicleId)
            this.form.fleet = response.payload.fleet
            setTimeout(() => {
                this.form.vehicle = {
                    registrationNumber: response.payload.registrationNumber,
                    id: response.payload.id
                }
            }, 1)
        },
        async getFleet () {
            const response = await fleetApi.getFleet(this.fleetId)
            this.form.fleet = response.payload
        }
    }
}
</script>

<style scoped lang="scss">
#device-create-view {
    .content-wrapper {
        margin-right: 40px;
    }
}
</style>
